import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import { DashboardTab } from './DashboardTab';
import { DetailsTab } from './DetailsTab';
import { StoppedInvoicesTab } from './StoppedInvoicesTab';
import { ArchivedTab } from './ArchivedTab';
import { AllInvoicesTab } from './AllInvoicesTab';
import { AllInvoicesFullTab } from './AllInvoicesFullTab';
import styles from './approval_persons_invoice_management.module.css';

export const ApprovalPersonsInvoiceManagement = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('action-required');
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('Approval Persons Invoice Management')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  return (
    <>
      <DashboardLayout padding={true}>
        <div className={styles['approval-persons-invoice-container']}>
          {/* Tabs */}
          <div className={styles['tabs-container']}>
            <button
              className={`${styles['tab']} ${selectedTab === 'dashboard' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('dashboard')}
            >
              Dashboard
            </button>
            <button
              className={`${styles['tab']} ${selectedTab === 'action-required' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('action-required')}
            >
              Active Invoices
            </button>
            <button
              className={`${styles['tab']} ${selectedTab === 'stopped-invoices' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('stopped-invoices')}
            >
              Stopped Invoices
            </button>
            <button
              className={`${styles['tab']} ${selectedTab === 'all-invoices' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('all-invoices')}
            >
              Closed Invoices
            </button>
            <button
              className={`${styles['tab']} ${selectedTab === 'archive' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('archive')}
            >
              Archive
            </button>
            <button
              className={`${styles['tab']} ${selectedTab === 'all-invoices-full' ? styles['tab-active'] : ''}`}
              onClick={() => setSelectedTab('all-invoices-full')}
            >
              All Invoices
            </button>
          </div>

          {/* Tab Content */}
          {selectedTab === 'dashboard' && <DashboardTab />}
          {selectedTab === 'action-required' && <DetailsTab />}
          {selectedTab === 'stopped-invoices' && <StoppedInvoicesTab />}
          {selectedTab === 'all-invoices' && <AllInvoicesTab />}
          {selectedTab === 'archive' && <ArchivedTab />}
          {selectedTab === 'all-invoices-full' && <AllInvoicesFullTab />}
        </div>
      </DashboardLayout>
    </>
  );
};
